// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 12303-新增推荐商品 POST /web/v1/recommendGoods/add */
export async function addRecommendGoods(
  body: API.SwimRecommendGoodsAddVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOLong>("/web/v1/recommendGoods/add", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 12306-查询可用商品列表 GET /web/v1/recommendGoods/availableGoods */
export async function getAvailableGoods(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getAvailableGoodsParams,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOListSwimAvailableGoodsVo>(
    "/web/v1/recommendGoods/availableGoods",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 12305-删除推荐商品 GET /web/v1/recommendGoods/delete/${param0} */
export async function deleteRecommendGoods(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteRecommendGoodsParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOBoolean>(
    `/web/v1/recommendGoods/delete/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 12302-推荐商品详情查询 GET /web/v1/recommendGoods/detail/${param0} */
export async function getRecommendGoodsDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getRecommendGoodsDetailParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOSwimRecommendGoodsDetailVo>(
    `/web/v1/recommendGoods/detail/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 12301-分页查询推荐商品列表 POST /web/v1/recommendGoods/pageList */
export async function getRecommendGoodsPageList(
  body: API.SwimRecommendGoodsPageQueryVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOYmPageResVOSwimRecommendGoodsListVo>(
    "/web/v1/recommendGoods/pageList",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 12304-修改推荐商品 POST /web/v1/recommendGoods/update */
export async function updateRecommendGoods(
  body: API.SwimRecommendGoodsUpdateVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/web/v1/recommendGoods/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}
